import { isCoolPacks } from 'common/helpers/featureFlags';

import CoolPack from '../shipping/components/CoolPack';

import CarrierPickupLocation from './contentSummary/CarrierPickupLocation';
import Customer from './contentSummary/Customer';
import Payment from './contentSummary/Payment';
import Shipping from './contentSummary/Shipping';

const ContentSummary = (props) => {
  const { cart, customer, currentStep, onEdit, settings } = props;
  if (currentStep === 'customer') {
    return null;
  }
  return (
    <>
      <div className="c7-checkout__content__summary">
        <Customer
          cart={cart}
          customer={customer}
          currentStep={currentStep}
          onEdit={onEdit}
          settings={settings}
        />
        <CarrierPickupLocation
          cart={cart}
          currentStep={currentStep}
          onEdit={onEdit}
          settings={settings}
        />
        <Shipping
          cart={cart}
          currentStep={currentStep}
          onEdit={onEdit}
          settings={settings}
        />
        <Payment
          cart={cart}
          currentStep={currentStep}
          onEdit={onEdit}
          settings={settings}
        />
      </div>
      {isCoolPacks() && currentStep === 'complete' && (
        <CoolPack cart={cart} settings={settings} />
      )}
    </>
  );
};
export default ContentSummary;
